import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";

export class POSTMentorAbsenceRequest {
    public rotaId: Guid = "";
    public mentorId: Guid = "";
    public absenseStartDate?: Date | string;
    public absenseEndDate?: Date | string;
}

export class POSTMentorAbsenceEndPoint extends Endpoint<POSTMentorAbsenceRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.WeeklyRota.SaveMentorRotaAbsence);
    }

    public async HandleRequestAsync(request: POSTMentorAbsenceRequest): Promise<POSTMentorAbsenceRequest> {
        return request;
    }

    public async HandleResponseAsync(response: any): Promise<any> {
        return response;
    }
}
